import React from "react";
import { useMyContext } from "src/hooks/context";
import * as API from "src/api/request";

const Layout = ({ children }) => {
  const { dispatch, type } = useMyContext();

  return (
    <div className="relative flex flex-col max-w-[1200px] min-h-screen bg-gray-200 justify-center items-center mx-auto">
      <div className="flex w-full items-center justify-end bg-gradient-to-r from-green-400 to-blue-600 p-2">
        <div
          className="border-2 shadow-md text-white font-bold h-8 text-md flex items-center rounded-lg hover:bg-blue-800 px-5 cursor-pointer"
          onClick={() =>
            API.logOut().then(() => {
              dispatch({ type: type.LOG_OUT });
              window.location.replace("https://digital.erdenetmc.mn");
            })
          }
        >
          <div className="absolute invisible md:visible top-1 left-[50%] -translate-x-[50%] text-white text-lg font-medium">
            Цалин тооцооны хуудас
          </div>
          Гарах
        </div>
      </div>
      <div className="flex min-h-[calc(100vh-50px)] top-10 w-full h-full text-xs md:text-md">
        {children}
      </div>
    </div>
  );
};

export default React.memo(Layout);
